<script lang="ts">
    import type {ZoomRangeWithBlocks} from "../zoom2.svelte.js";
    import type { PageStateAny} from "../state";
    import {isStateJob,} from "../state";
    type Props = {
        currentZoom: ZoomRangeWithBlocks;
        rowLineHeight: number;
        pageState: PageStateAny;
    };
    let i = $state(false);
    let interval = setInterval(() => {
        i = !i;
    }, 200);

    let {currentZoom, rowLineHeight, pageState}: Props = $props();
    function getWeekendBackground(date: Date): string {
        if (!date) return "#00000000";

        // Out-of-bounds check takes priority
        if(isStateJob(pageState) && pageState.selected?.item?.job?.start_date_time && pageState.selected?.item?.job?.end_date_time){
            // eslint-disable-next-line svelte/prefer-svelte-reactivity
            let s = new Date(pageState.selected?.item?.job?.start_date_time).setHours(0,0,0,0)
            let e = new Date(pageState.selected?.item?.job?.end_date_time).setHours(0,0,0,0)

            if ( (date < s|| date > e)) return "#ff000025";
        }

        // Weekend shading
        const day = date.getDay();
        if (day === 0 || day === 6) return "#00000020";

        return "#00000000";
    }


</script>

<div
    class="scheduler-col-lines"
    style:--cell-width={`${currentZoom.cellPx}px`}
    style:--row-line-height={`${rowLineHeight}px`}
>
    {#each currentZoom.blocks as block}
        <div class="block">
            {#each block.cells as cell}
                <div class="cell"
                     style:--background="{getWeekendBackground(cell.date)}"
                ></div>
            {/each}
        </div>
    {/each}
</div>

<style lang="scss">
    .scheduler-col-lines {
        display: flex;
        background: hsl(var(--clr-surface-0));
        height: fit-content;
    }

    .block {
        position: relative;
        height: fit-content;
        display: flex;
    }

    .cell {
        border-left: solid 1px #444;
        border-bottom: solid 1px #444;
        width: var(--cell-width);
        position: relative;
        padding: 0 0.25rem;
        height: 100%;
    }

    .cell::before {
        content: "";
        position: absolute;
        top: 100%;
        left: -1px;
        height: var(--row-line-height);
        width: 100%;
        background: var(--background);
        pointer-events: none;
    }

    .block::after,
    .cell::after {
        z-index: 5;
        content: "";
        position: absolute;
        top: 100%;
        left: -1px;
        height: var(--row-line-height);
        width: 1px;
        background: #33333380;
        transition: height 200ms;
    }

    .block::after {
        width: 2px;
    }

    .cell:first-child {
        border-left: 0;
    }
</style>
